module.exports = __webpack_public_path__ + "app/assets/images/woman2-7af3148ad051e80db41ba25fca41794e.jpg";